<script>
import ModelCreate from "../models/create";
import FormsModel from "@/components/forms/driver";

export default {
  extends: ModelCreate,
  page: {
    title: "Create Drivers",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('drivers.singular')) }},
    resourceRoute: {default: 'drivers'},
    modelVariable: {default: 'driver'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('drivers.plural')),
      items: [
        {
          text: this.lodash.startCase(this.$t('drivers.plural')),
          href: "/drivers",
        },
        {
          text: this.$t("Create New"),
          href: "/drivers/create",
          active: true,
        },
      ]
    }
  },
  methods: {
    store(value) {
      return this.$axios.post('/drivers', value);
    }
  }
}
</script>
